import { CompanyUserSummary } from '@treasury/domain/company/user';

export class CompanyUserViewModel extends CompanyUserSummary {
    constructor(companyUser: CompanyUserSummary) {
        super(companyUser.toDto());
        this.isActiveValue = companyUser.isActive ? 'Active' : 'Deactivated';
        this.isEnrolledValue = companyUser.isEnrolled;
        this.isPendingValue = companyUser.isNotEnrolled;
        this.lastViewed = companyUser.lastViewed;
        this.roleList = companyUser.roles.join(', ');
        // Add a sortable value that's always a valid date string for proper sorting
        // Use epoch (far past) for undefined so they sort last when descending
        // This ensures date-fns compareAsc/compareDesc always receive valid date strings
        this.lastViewedForSort = companyUser.lastViewed || new Date(0).toISOString();
    }

    public readonly isActiveValue: string;

    public readonly isEnrolledValue: boolean;

    public readonly isPendingValue: boolean;

    public readonly roleList: string;

    public readonly lastViewedForSort: string;
}
